import React from 'react';
import filter from '../../filter';
import ListStats from '../ListStats';
import ListTable from '../ListTable';
import ListResults from '../ListResults';
import Print from '../Print';
import shallowequal from 'shallowequal';
import Alert from "../Alert";
import {executeQuery} from "../../requests/executeQuery";
import {V7_PROPERTIES_LIST, V7_PROPERTIES_STATS, V7_PROPERTIES_STATS_ACTIVE, V7_PROPERTIES_STATS_COUNT} from '../../consts/queries';
import LinkComp from '../LinkComp';
import Icon from '../Icon';
import plus from '../../svgs/plus-white.svg';

let cloneDeep = require('lodash.clonedeep');
const limit = 100;

export default class Listing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            originalItems: [],
            totalCount: 0,
            stats: null,
            error: null,
            isBusy: null,
            query: this.props.location.query,
            underwritingSuccess: false,
            underwritingError: false,
            selectedNo: 0,
            unselectedNo: 0,
            areRemovedItems: false,
            selectionStats: false,
        };

        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.removeSelected = this.removeSelected.bind(this);
        this.removeUnselected = this.removeUnselected.bind(this);
        this.reset = this.reset.bind(this);
        this.updateStats = this.updateStats.bind(this);
    }

    componentDidMount() {
        this.fetch(this.props.location.query);
        window.history.replaceState(null, '');
    }

    static getOptions(query) {
        const options = filter(query);
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;
        return options;
    }

    static setQueryOrder(q) {
        const query = {...q};
        if (query.SOURCE && query.SOURCE.toLowerCase() === 'strive' &&
            (query.STATUS && query.STATUS.toLowerCase() === 'closed' || query.HSC_STATUS && query.HSC_STATUS.toLowerCase() === 'closed')) {
            if (Array.isArray(query.order) && query.order.indexOf('CLOSE_OF_ESCROW.desc') === -1) {
                query.order.push('CLOSE_OF_ESCROW.desc');
                return query;
            }
            if (!query.order) {
                query.order = 'CLOSE_OF_ESCROW.desc';
            }
        }
        return query;
    }

    fetch(q) {
        this.setState({isBusy: true});

        const query = Listing.setQueryOrder(q);
        const options = Listing.getOptions(query);
        const statsQueryName = query.hasOwnProperty('SOURCE') && query.SOURCE === 'STRIVE' && query.hasOwnProperty('STATUS') && query.STATUS === 'Active' ? V7_PROPERTIES_STATS_ACTIVE : V7_PROPERTIES_STATS;

        Promise.all([
            executeQuery({queryName: V7_PROPERTIES_LIST, options, expireTime: 1000 * 10}),
            executeQuery({queryName: statsQueryName, options, expireTime: 1000 * 10}),
            executeQuery({queryName: V7_PROPERTIES_STATS_COUNT, options, expireTime: 1000 * 10}),
        ]).then(values => {
            let originalItems = values[0].success ? values[0].data : [];
            originalItems.forEach(item => item.SELECTED = false);

            const existingItems = cloneDeep(this.state.items);
            let items = cloneDeep(originalItems);
            let selectedNo = 0;
            let unselectedNo = originalItems.length ? originalItems.length : 0;
            let areRemovedItems = this.state.areRemovedItems;

            // Merge response items with selected ones
            if (values[0].success && areRemovedItems && query.page === this.state.query.page) {
                let newItems = [];
                for (let index = 0; index < originalItems.length; index++) {
                    const itemFound = existingItems.find(item => originalItems[index].ARCIMEDES_ROW_ID === item.ARCIMEDES_ROW_ID);
                    if (itemFound) {
                        newItems.push(itemFound);
                    }
                }

                unselectedNo = 0;
                newItems.forEach(newItem => {
                    if (newItem.SELECTED) {
                        selectedNo++;
                    } else {
                        unselectedNo++;
                    }
                });
                items = newItems;
            }

            this.setState({
                originalItems: originalItems,
                items: items,
                totalCount: values[2].data && values[2].data.length && typeof values[2].data[0].count === 'string' ? Number(values[2].data[0].count) : limit,
                stats: values[1].data[0],
                error: values[0].success ? null : values[0].message,
                isBusy: null,
                query,
                underwritingSuccess: false,
                underwritingError: false,
                selectedNo: selectedNo,
                unselectedNo: unselectedNo,
            });
        });
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    handleCheckboxChange(e) {
        let {selectedNo, unselectedNo} = this.state;
        const items = cloneDeep(this.state.items);
        const name = e.target.name;
        items[name].SELECTED = !items[name].SELECTED;
        if (items[name].SELECTED) {
            selectedNo++;
            unselectedNo--;
        } else {
            selectedNo--;
            unselectedNo++;
        }
        this.setState({items, selectedNo, unselectedNo});
    }

    removeSelected() {
        const items = this.state.items.filter(item => !item.SELECTED);
        this.setState({
            items,
            selectedNo: 0,
            areRemovedItems: true,
        });
    }

    removeUnselected() {
        const items = this.state.items.filter(item => item.SELECTED);
        this.setState({
            items,
            unselectedNo: 0,
            areRemovedItems: true,
        });
    }

    reset() {
        const originalItems = this.state.originalItems;

        if (this.state.selectionStats) {
            this.setState({isBusy: true});

            const query = Listing.setQueryOrder(this.state.query);
            const options = Listing.getOptions(query);
            const statsQueryName = query.hasOwnProperty('SOURCE') && query.SOURCE === 'STRIVE' && query.hasOwnProperty('STATUS') && query.STATUS === 'Active' ? V7_PROPERTIES_STATS_ACTIVE : V7_PROPERTIES_STATS;

            executeQuery({queryName: statsQueryName, options, expireTime: 1000*10}).then(res => {
                this.setState({
                    isBusy: null,
                    stats: res.data[0],
                    items: cloneDeep(originalItems),
                    selectedNo: 0,
                    unselectedNo: originalItems.length,
                    areRemovedItems: false,
                    selectionStats: false,
                });
            });
            return;
        }

        this.setState({
            items: cloneDeep(originalItems),
            selectedNo: 0,
            unselectedNo: originalItems.length,
            areRemovedItems: false,
            selectionStats: false,
        });
    }

    updateStats() {
        const stats = {
            count: 0,
        };
        const sums = {
            LIST_PRICE: 0,
            NEGOTIATION_PRICE: 0,
            SOLD_PRICE: 0,
            HSC_PRICE: 0,
            SQFT: 0,
            VACANCY: 0,
            DOWN_PAYMENT: 0,
            SELLER_FEE_PERCENTAGE: 0,
            NET_OPERATING_INCOME: 0,
            CLOSE_NOI: 0,
            CAPITALIZATION_RATE: 0,
            NEGOTIATION_CAP_RATE: 0,
            CLOSE_CAP_RATE: 0,
            RENT_PER_SQFT: 0,
            PRICE_PER_SQFT: 0,
            NEGOTIATION_PRICE_PER_SQFT: 0,
            CLOSE_PRICE_PER_SQFT: 0,
        };
        const items = this.state.items;

        items.forEach(item => {
            if (item.STATUS !== 'Active' || item.STATUS === 'Active' && item.LIST_PRICE) {
                stats.count++;
            }
            Object.keys(sums).forEach(key => {
                sums[key] += Number(item[key]);
            });
        });

        stats.TOTAL_LIST_PRICE = sums.LIST_PRICE;
        stats.TOTAL_NEGOTIATION_PRICE = sums.NEGOTIATION_PRICE;
        stats.TOTAL_SOLD_PRICE = sums.SOLD_PRICE;
        stats.TOTAL_HSC_PRICE = sums.HSC_PRICE;
        stats.TOTAL_SQFT = sums.SQFT;

        if (stats.count) {
            Object.keys(sums).forEach(key => {
                stats[key] = sums[key] / stats.count;
            });
        }

        this.setState({stats, selectionStats: true});
    }

    render() {
        const error = this.props.location.state && this.props.location.state.error;
        const success = this.props.location.state && this.props.location.state.success;
        const {items, originalItems, totalCount, stats, isBusy, query, checkboxes, selectedNo, unselectedNo, areRemovedItems} = this.state;

        return (
            <div className="Listing" data-is-busy={isBusy}>
                <div className="page-rounded-corner-container">
                    <div className="page-header-container list">
                        <ListStats stats={stats} query={query}/>
                        <div className="page-header list">
                            <div className="page-title">Properties</div>
                            <LinkComp to={`${arc.path.base}property`}>
                                <div className="button-new plus positive">
                                    <Icon svg={plus}/>
                                </div>
                            </LinkComp>
                        </div>
                        <div className="line"/>
                        <div className="buttons-container">
                            <button className={`button-new text ${!selectedNo || selectedNo === items.length ? "inactive" : ""}`}
                                    onClick={this.removeSelected}>
                                Remove Selected
                            </button>
                            <button className={`button-new text ${!unselectedNo || unselectedNo === items.length ? "inactive" : ""}`}
                                    onClick={this.removeUnselected}>
                                Remove Unselected
                            </button>
                            <button className={`button-new text ${items.length !== originalItems.length ? "" : "inactive"}`}
                                    onClick={this.reset}>
                                Reset List
                            </button>
                            <button className={`button-new text ${areRemovedItems ? "" : "inactive"}`}
                                    onClick={this.updateStats}>
                                Show Page Stats
                            </button>
                        </div>
                    </div>
                </div>
                <Print location={this.props.location} listings={items}/>
                {error ? <Alert type="error">{error}</Alert> : null}
                {success ? <Alert type="success">{success}</Alert> : null}

                <div className="page-body-container">
                    <ListTable location={this.props.location}
                               listings={items}
                               isSuper={this.props.isSuper}
                               isAgent={this.props.isAgent}
                               checkboxes={checkboxes}
                               toggleCheckbox={this.handleCheckboxChange}
                    />
                    <ListResults query={this.props.location.query}
                                 pathname={this.props.location.pathname}
                                 error={this.state.error}
                                 totalCount={totalCount}
                                 itemCount={items ? items.length : false}
                                 originalItemCount={originalItems ? originalItems.length : false}
                                 limit={limit}
                                 className="properties"
                    />
                </div>
            </div>
        );
    }
}
